module.exports = __webpack_public_path__ + "static/img/40007 (4).bef2be5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40007 (4).webp
// module id = fmie
// module chunks = 14